/**
 * Clé stable pour une notification toast commande / RDV (session admin).
 */

export function getNotificationEventKey(notification) {
  const { type, data = {}, timestamp } = notification || {};
  const payload = data && typeof data === 'object' ? data : {};

  if (type === 'rendezvous') {
    const id = payload.rendezVousId ?? payload.id ?? payload.commandeId;
    if (id != null && id !== '') {
      return `rendezvous:${id}`;
    }
    return `rendezvous:ts:${timestamp ?? payload.timestamp ?? 'unknown'}`;
  }

  if (type === 'commande') {
    const id = payload.commandeId ?? payload.id ?? payload.numero;
    if (id != null && id !== '') {
      return `commande:${id}`;
    }
    return `commande:ts:${timestamp ?? payload.timestamp ?? 'unknown'}`;
  }

  const fallbackId =
    payload.id ?? payload.commandeId ?? payload.rendezVousId ?? payload.numero;
  if (fallbackId != null && fallbackId !== '') {
    return `${type || 'event'}:${fallbackId}`;
  }
  return `${type || 'event'}:ts:${timestamp ?? 'unknown'}`;
}
